import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export const startCanvasConnect = (
  instrFirstName,
  instrEmail,
  instrId,
  instrCourses,
  connectedCourses,
  hasScopedKey
) => {
  const root = createRoot(document.getElementById('canvasConnectApp'))
  root.render(
    <App
      instrFirstName={instrFirstName}
      instrEmail={instrEmail}
      instrId={instrId}
      instrCourses={instrCourses}
      connectedCourses={connectedCourses}
      hasScopedKey={hasScopedKey === 'true'}
    />
  )
}
